// do these things only once
// even if you are using a history.js navigation

// imports --------------------------------------------------------------------
import * as Vars from './0-vars.js';
import * as Once from './2-once.js';
import * as Page from './3-page.js';
import * as Resize from './4-resize.js';
import * as Scroll from './5-scroll.js';
import * as SC from '../js_vendor/Soundcloud-api.js';

// exported variables ---------------------------------------------------------
export let tickerPaused = false;
export let fromKeyboard = false;

// local variables ------------------------------------------------------------
// let firstClick = true;

// listeners function ---------------------------------------------------------
export const initListeners = () => {
  // console.log('listeners');
  
  // touch --------------------------------
  const hoverSelector = 'button, a, input';
  document.body.addEventListener('touchstart', event => { // also triggers on move
    // console.log('touchstart', event.target.classList[0]);

    // add touch hover classes
    let el = elFromEvent(hoverSelector, event);
    if (el) el.classList.add('hover');
  });

  document.body.addEventListener('touchend', event => {
    // console.log('touchend', event.target.classList[0]);

    let el = elFromEvent(hoverSelector, event);
    if (el) el.classList.remove('hover');
  });

  // touch and mouse --------------------------------
  document.body.addEventListener('click', event => { // triggers on tap, not on move
    // console.log('click', event.target.classList[0]);

    // remove focus after click
    let el = elFromEvent('button, a, input[type="radio"], input[type="checkbox"], *[role="button"], input[type=range]', event);
    if (el && event.clientX !== 0 && event.clientY !== 0) el.blur();

    const headerLinksEl = document.querySelector('.header-links');
    el = elFromEvent('.header-links', event);
    if (Vars.blTouch && headerLinksEl) {
      if (el === headerLinksEl) {
        el.classList.toggle('header-links--active');
      } else {
        headerLinksEl.classList.remove('header-links--active');
      }
    }

    el = elFromEvent('#js-shuffle', event);
    if (el) Page.randomizeSlides();

    el = elFromEvent('#js-newsletter', event);
    if (el) Scroll.animateScrollTop(1000000);

    el = elFromEvent('.hamburger', event);
    if (el) document.body.classList.toggle('body--nav');

    el = elFromEvent('.camping__item--filter, .camping__item--filter .button', event);
    if (el) setCampingFilter(el);

    el = elFromEvent('.values__item-holder', event);
    if (el && Vars.blTouch){
      const valueItemHolderEls = document.querySelectorAll('.values__item-holder');
      valueItemHolderEls.forEach(item => item.classList.remove('values__item-holder--active'));
      el.classList.add('values__item-holder--active');
    }

    el = elFromEvent('.js-anchors .button', event);
    if (el) {
      const anchor = el.dataset.anchor;
      if (anchor) scrollToAnchor(anchor);
    } 

    el = elFromEvent('.info__button', event);
    if (el) {
      const clipboard = el.dataset.clipboard;
      if (clipboard) navigator.clipboard.writeText(clipboard);
    }

    el = elFromEvent('.sound-btn', event);
    if (el) startSound(el);

    el = elFromEvent('.nav-sound', event);
    if (el) disableSound();

    // click anywhere but not on audio button to unmute home video on first click
    // el = event.target.closest('.media__btn--audio');
    // const homeVideoAudioOnMuteEl = document.querySelector('.media-holder .media__btn--audio');
    // const homeMediaEl = document.querySelector('.media-holder .media');
    // if (!el && homeMediaEl && homeVideoAudioOnMuteEl) {
    //   if (homeMediaEl.classList.contains('media--muted') && firstClick) {
    //     homeVideoAudioOnMuteEl.click();

    //     const navSound = document.querySelector('.nav-sound');
    //     if (navSound) navSound.classList.add('nav-sound--active');
    //   }
    // }

    // firstClick = false;
  });

  // keyboard --------------------------------
  document.body.addEventListener('keydown', event => {
    // console.log('keydown', event.key);
    fromKeyboard = true;
  });

  // mouse and keyboard --------------------------------
  // mouseout, focusout listeners 
  const outHandler = event => {
    // use if (event.type === 'mouseout') to avoid keyboard blur
    if (Vars.blTouch) return;
    if (event.type === 'focusout' && !fromKeyboard) return;
    // console.log('outHandler', event.target.classList[0], event.type);

    // let el = elFromEvent(swiperHoverSelector, event);
    // if (el && Once.aim) {
    //   Once.aim.classList.remove('animate-it-mouse--hover');
    // }

    // el = elFromEvent('.swiper-wrapper', event);
    // if (el && Once.aim) {
    //   Once.aim.classList.remove('animate-it-mouse--drag-hor');
    // }

    el = elFromEvent('.ticker', event);
    if (el) tickerPaused = false;

    el = elFromEvent('.hamburger', event);
    if (el) document.body.classList.remove('body--hover');

    el = elFromEvent('.randomizer__image', event);
    if (el) {
      const nameEls = document.querySelectorAll('.randomizer__name--active');
      nameEls.forEach(nameEl => nameEl.classList.remove('randomizer__name--active'));
    }

    el = elFromEvent('.news__item', event);
    if (el) {
      const newsItemEls = document.querySelectorAll('.news__item--active');
      newsItemEls.forEach(newsItemEl => newsItemEl.classList.remove('news__item--active'));
    }
  };

  // document.body.addEventListener('mouseleave', outHandler, true); // bubbles to body, triggers on touch
  document.body.addEventListener('mouseout', outHandler); // doesn't bubble, triggers on touch
  document.body.addEventListener('focusout', outHandler); // doesn't bubble or trigger on touch, triggers on keyboard blur and click on other button

  // mouseover, focusin listeners 
  const swiperHoverSelector = '.swiper-pagination-bullet, .swiper-button-next, .swiper-button-prev';
  const inHandler = event => {
    // use if (event.type === 'mouseover') to avoid keyboard focus
    if (Vars.blTouch) return;
    if (event.type === 'focusin' && !fromKeyboard) return;
    // console.log('inHandler', event.target.classList[0], event.type);

    // let el = elFromEvent(swiperHoverSelector, event);
    // if (el && Once.aim) {
    //   Once.aim.classList.add('animate-it-mouse--hover');
    // }

    // el = elFromEvent('.swiper-wrapper', event);
    // if (el && Once.aim) {
    //   Once.aim.classList.add('animate-it-mouse--drag-hor');
    // }

    el = elFromEvent('.ticker', event);
    if (el)  tickerPaused = true;

    el = elFromEvent('.hamburger', event);
    if (el) document.body.classList.add('body--hover');

    // show hover on related slider
    el = elFromEvent('.randomizer__image', event);
    if (el) {
      const href = el.getAttribute('href');
      const slider = el.closest('.randomizer__slider--images');
      // console.log({href, slider});
      if (!slider) return;

      const nr = slider.getAttribute('data-nr');
      const otherSliderEl = document.querySelector(`.randomizer__slider--texts[data-nr="${nr}"]`);
      // console.log({nr, otherSliderEl});
      if (!otherSliderEl) return;

      const otherSlideEl = otherSliderEl.querySelector('.randomizer__name[href="' + href + '"]');
      // console.log({otherSlideEl});
      if (!otherSlideEl) return;

      otherSlideEl.classList.add('randomizer__name--active');
    }

    // show hover on related news slider
    el = elFromEvent('.news__item', event);
    if (el) {
      const href = el.getAttribute('href');
      const newsSlider = el.closest('.news__slider--images');
      const otherSliderEl = document.querySelector(`.news__slider--texts`);
      if (!newsSlider || !otherSliderEl) return;

      const otherSlideEl = otherSliderEl.querySelector(`.news__item[href="${href}"]`);
      if (otherSlideEl) otherSlideEl.classList.add('news__item--active');
    }

    // keyboard focus footer
    if (event.type == 'focusin' && fromKeyboard && event.target.closest('.footer')) {
      Scroll.animateScrollTop(1000000);
    }

    fromKeyboard = false;
  };

  // document.body.addEventListener('mouseenter', inHandler, true); // bubbles to body, triggers on touch
  document.body.addEventListener('mouseover', inHandler); // doesn't bubble, triggers on touch
  document.body.addEventListener('focusin', inHandler); // doesn't bubble or trigger on touch, triggers on keyboard focus and mousedown on button


  // mousedown listener --------------------------------
  document.body.addEventListener('mousedown', event => {
    // console.log('mousedown', event.target.classList[0]);

    // el = elFromEvent('.swiper-wrapper', event);
    // if (el && Once.aim) {
    //   Once.aim.classList.add('animate-it-mouse--dragging-hor');
    // }
  }, true);

  // mousemove listener --------------------------------
  document.body.addEventListener('mousemove', event => {
    // console.log('mousemove', event.target.classList[0]);

    const x = event.clientX;
    const y = event.clientY;
  }, true);

  // mouseup listener --------------------------------
  document.body.addEventListener('mouseup', event => {
    // console.log('mouseup', event.target.classList[0]);

    // if (Once.aim) {
    //   Once.aim.classList.remove('animate-it-mouse--dragging-hor');
    // }
  }, true);


  // submit listerer ------------------------------
  document.body.addEventListener('submit', event => {
    const formEl = event.target;
    if (!formEl) return;

    if (formEl.classList.contains('js-newsletter-api')) {
      event.preventDefault();

      const emailEl = formEl.querySelector('.form__input-text');
      if (!emailEl) return;

      const email = emailEl.value;
      if (!email) return;

      const url = $baseUrl + 'cms/wp-admin/api/submit-newsletter.php?email=' + email;

      // console.log({email, url});

      const options = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const pEl = formEl.querySelector('.fold-out p');
      const foldoutBtnEl = formEl.querySelector('.form__foldout-btn');
      let text;

      fetch(url, options)
        .then(response => response.json())
        .then(data => {
          // console.log('Success:', data);

          if (data.success === true) {
            text = formEl.dataset.thanks;
          } else {
            text = JSON.stringify(data, null, 2);
          }

          if (!pEl || !foldoutBtnEl) {
            console.error(text);
          } else {
            pEl.innerHTML = text;
            foldoutBtnEl.click();

            setTimeout(() => {
              foldoutBtnEl.click();
            }, 3000);
          }
        })
        .catch(error => {
          // console.error('Error:', error);

          if (!pEl || !foldoutBtnEl) {
            console.error(error);
          } else {
            pEl.innerHTML = error;
            foldoutBtnEl.click();
          }
        });

      // test2@littlefragments.com
    }
  });

};

// functions -------------------------------------------------------------------
export const scrollToAnchor = (anchor) => {
  const anchorEl = document.querySelector('.heading[data-anchor="' + anchor + '"]');
  if (anchorEl) Scroll.scrollToEl(anchorEl);
};

const setCampingFilter = (el)=> {
  const campingItemFilterEls = document.querySelectorAll('.camping__item--filter');
  campingItemFilterEls.forEach(item => item.classList.remove('camping__item--active'));

  el.classList.add('camping__item--active');
  const filter = el.dataset.filter;

  const campingEl = document.querySelector('.camping--items');
  if(!campingEl) return;

  campingEl.classList.add('camping--faded');

  setTimeout(() => {
    const campingItems = campingEl.querySelectorAll('.camping__item');
    campingItems.forEach(item => item.classList.add('camping__item--hidden'));

    if (filter === 'all') {
      campingItems.forEach(item => item.classList.remove('camping__item--hidden'));
    } else {
      campingEl.querySelectorAll(`.camping__item[data-terms~="${filter}"]`).forEach(item => {
        item.classList.remove('camping__item--hidden');
      });
    }

    campingEl.classList.remove('camping--faded');
    Once.fader.fadeInHolderAgain('.camping--items');

    const firstCampingItemEl = campingEl.querySelector('.camping__item:not(.camping__item--hidden)');
    if (firstCampingItemEl) Scroll.scrollToEl(firstCampingItemEl);
  }, Vars.transitionDefault);
};

const startSound = (el) => {
  const soundActive = el.classList.contains('sound-btn--active');

  document.querySelectorAll('.sound-btn').forEach(item => item.classList.remove('sound-btn--active'));
  disableSound();

  if (!soundActive) {
    el.classList.add('sound-btn--active');

    const navSound = document.querySelector('.nav-sound');
    if (navSound) navSound.classList.add('nav-sound--active');

    // load sc html
    const nr = parseInt(el.getAttribute('data-nr'), 10);
    const soundHTML = el.classList.contains('sound-btn--2') ? $program[nr].sound_button_embed_2 : $program[nr].sound_button_embed;
    // console.log({nr, soundHTML});
    const soundcloudHolder = document.querySelector('#soundcloud-holder');
    if (soundcloudHolder) soundcloudHolder.innerHTML = soundHTML;

    // play sc widget
    const scElement = document.querySelector('#soundcloud-holder iframe');
    if (scElement) {
      // console.log({scElement}, SC.SC);
      const scWidget = SC.SC.Widget(scElement);
      scWidget.bind(SC.SC.Widget.Events.READY, () => {
        scWidget.play();
      });
    }
  }
}

export const disableSound = () => {
  const navSound = document.querySelector('.nav-sound');
  if (navSound) navSound.classList.remove('nav-sound--active');

  const programItemSounds = document.querySelectorAll('.sound-btn');
  programItemSounds.forEach(item => item.classList.remove('sound-btn--active'));

  const soundcloudHolder = document.querySelector('#soundcloud-holder');
  if (soundcloudHolder) soundcloudHolder.innerHTML = '';

  const homeVideoAudioOnMuteEl = document.querySelector('.media-holder .media__btn--audio');
  const homeMediaEl = document.querySelector('.media-holder .media');
  if (homeMediaEl && homeVideoAudioOnMuteEl) {
    if (!homeMediaEl.classList.contains('media--muted')) homeVideoAudioOnMuteEl.click();
  }

  // const popoverVideo = document.querySelector('.popover .video');
  // if (popoverVideo) popoverVideo.innerHTML = '';
}

export const elFromEvent = (selector, event) => {
  // will return the element that matches the selector
  // returns for every sub element of the selector
  const {target} = event;
  const ancestor = target.closest(selector);
  return ancestor || target.matches(selector);
};

